var _rect, _path, _path2, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 110,
    fill: "#E7F8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3383_3646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 194,
    height: 194
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.944 134.903L125.583 142.542L140.861 127.264",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1835 69.6667H134.5C136.157 69.6667 137.5 71.0099 137.5 72.6667V112.339M94.1835 69.6667L75.1665 88.6323M94.1835 69.6667V86.6323C94.1835 87.7368 93.288 88.6323 92.1835 88.6323H75.1665M75.1665 88.6323V149.167C75.1665 150.824 76.5096 152.167 78.1665 152.167H112.144M87.9998 99.0001H124.667M87.9998 111.833H124.667M87.9998 124.667H108.167",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1665,
    y: 16.1667,
    width: 189.5,
    height: 189.5,
    rx: 94.75,
    stroke: "#0078BB",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3383_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.167 110.917C207.167 164.074 164.074 207.167 110.917 207.167C57.7591 207.167 14.6665 164.074 14.6665 110.917C14.6665 57.7593 57.7591 14.6667 110.917 14.6667C164.074 14.6667 207.167 57.7593 207.167 110.917Z",
    fill: "url(#paint0_linear_3383_3646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3383_3646",
    x1: 111.833,
    y1: -21.9999,
    x2: 110.917,
    y2: 207.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/form_icon.6be891f6c18a4b5653905aff4a261e24.svg";
export { ForwardRef as ReactComponent };